import { render, staticRenderFns } from "./AdminReleases.vue?vue&type=template&id=d5054e38&"
import script from "./AdminReleases.vue?vue&type=script&lang=ts&"
export * from "./AdminReleases.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports